import { render } from "./DictionaryColorList.vue?vue&type=template&id=50d79fb0"
import script from "./DictionaryColorList.vue?vue&type=script&lang=js"
export * from "./DictionaryColorList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__